import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { CalculateVenueEss } from '../entities/calculate-venue-ess.entity';

type Params = {
  projectId: number;
};

type Result = {
  ess: CalculateVenueEss;
};

export const runImpactCalculateVenueEssForProject = createAppAsyncThunk(
  'impactCalculateVenue/runImpactCalculateVenueEssForProject',
  async (
    params: Params,
    { extra: { impactCalculateVenueGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const modelVersion = 'ESS_SEASON';
      const calculateEss =
        await impactCalculateVenueGateway.runImpactCalculateVenueEssForProject(
          params.projectId,
          modelVersion,
        );
      return { ess: calculateEss };
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
